import { DesignChannel } from 'components/NewFileModal/Types'

export const channelSupportsCaption = (channel: DesignChannel) => {
  return [
    DesignChannel.InstagramPost,
    DesignChannel.InstagramReel,
    DesignChannel.TikTokPost,
    DesignChannel.FacebookPost,
    DesignChannel.LinkedInPost,
    DesignChannel.TwitterPost,
    DesignChannel.YoutubeShort,
  ].includes(channel)
}
